(ns client-portal.client.drive-thru.locations.list.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [shared.core.components.auth0.data :as auth0.d]
            [shared.core.router :as router]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def root-path [:drive-thru :locations :list])
(def by-concept-id-path (conj root-path :by-concept-id))
(def by-route-concept-id-location-id-path (conj root-path :by-route-concept-id-location-id))

(re/reg-event-db
  :drive-thru/locations-list-go-with-params re/middleware
  (fn [db]
    (re/dispatch [:router/go [:drive-thru/locations-list
                              nil
                              (->> {:cid (some-> (concepts.d/current-concept-id db)
                                                 (str))}
                                   (filter (fn [[_ v]] (not-empty v)))
                                   (into {}))]])
    db))

(re/reg-auth0-loader
  :drive-thru/load-locations-by-current-concept-id
  (fn [_ db]
    (when-let [concept-id (concepts.d/current-concept-id db)]
      (conj by-concept-id-path concept-id)))
  (fn [db]
    (when-let [concept-id (concepts.d/current-concept-id db)]
      {:method :get
       :url "/api/drive-thru/locations"
       :query-params {:concept-id concept-id}}))
  :transf (fn [resp] (or (some-> resp :body (util/->kebab-case-keywords))
                         ""))
  :error-transf (fn [] []))

(re/reg-auth0-load-sub
  :drive-thru/locations-by-current-concept-id-
  (fn [_ db]
    (when-let [concept-id (concepts.d/current-concept-id db)]
      (conj by-concept-id-path concept-id)))
  :drive-thru/load-locations-by-current-concept-id)

(re/reg-auth0-loader
  :drive-thru/load-location-by-current-route-concept-id-location-id
  (fn [_ db]
    (let [{:keys [concept-id location-id]} (router/current-path-params db)]
      (conj by-route-concept-id-location-id-path concept-id location-id)))
  (fn [db]
    (let [{:keys [concept-id location-id]} (router/current-path-params db)]
      (when (and (not-empty concept-id) (not-empty location-id))
        {:method :get
         :url (str "/api/drive-thru/location/" location-id)
         :query-params {:concept-id concept-id}})))
  :transf (fn [resp] (or (some-> resp :body (util/->kebab-case-keywords))
                         ""))
  :error-transf (fn [] {}))

(re/reg-auth0-load-sub
  :drive-thru/location-by-current-route-concept-id-location-id-
  (fn [_ db]
    (let [{:keys [concept-id location-id]} (router/current-path-params db)]
      (conj by-route-concept-id-location-id-path concept-id location-id)))
  :drive-thru/load-location-by-current-route-concept-id-location-id)

